module.exports = __webpack_public_path__ + "static/media/termopary5kz.999a2b1b.pdf";